import React from "react";
import NavBar from "../../components/NavBar/Navbar";
import { Route, Routes } from "react-router-dom";
import Home from "./home/Home";
import About from "./about/About";
import Services from "./services/Services";
import Career from "./career/Career";
import News from "./news/News";
import Contact from "./contact/Contact";
import NotFoundPage from "../notfound";
import { Layout } from "../../nq-component";
import Sidebar from "../main/components/sidebar";
import BasePage from "../../base/BasePage";
import withRouter from "../../utils/withRouter";
import menus from "./config/menus.json";
import PublicRoutesPresenter from "./PublicRoutesPresenter";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { findObjectUseCase } from "../../usecases/object";

class PublicRoutes extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new PublicRoutesPresenter(this, getAllSchemasUseCase());
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  navigateToSignin() {
    this.navigateTo("/signin");
  }

  render() {
    return (
      <Layout>
        <Layout.Context.Consumer>
          {(value) => (
            <Sidebar
              value={value}
              user={null}
              onClickMenu={this.onClickMenu.bind(this)}
              onClick={this.navigateToSignin.bind(this)}
              menu={menus}
            />
          )}
        </Layout.Context.Consumer>
        <main className="d-flex flex-column bg-white">
          <NavBar />
          <Routes>
            {/* PUBLIC PAGES */}
            <Route exact path={"/"} element={<Home />} />
            <Route exact path={"/about"} element={<About />} />
            <Route exact path={"/services"} element={<Services />} />
            <Route exact path={"/career"} element={<Career />} />
            <Route exact path={"/news"} element={<News />} />
            <Route exact path={"/contact"} element={<Contact />} />
            <Route element={<NotFoundPage />} />
          </Routes>
          {/* <Footer /> */}
        </main>
      </Layout>
    );
  }
}

export default withRouter(PublicRoutes);
